import script from "./ConfirmStocOneClickkModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmStocOneClickkModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmStocOneClickkModal.vue?vue&type=style&index=0&id=cada98d6&lang=scss"
import "./ConfirmStocOneClickkModal.vue?vue&type=style&index=1&id=cada98d6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cada98d6"]])

export default __exports__